import { useEffect, useState, useContext } from "react";
import { Card, Space, Image, notification,Row, Col } from "antd";
import { useParams, useLocation } from "react-router-dom";
import { getMap, getVisuals } from "../API";
import {FarmerContext} from '../Helper/Context';
import bgimage from '../images/monitor-back.png';

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function Water() {
  const {farmerData, setFarmerData} = useContext(FarmerContext);
  const [prevVisible, setPrevVisible] = useState(false);
  const { cropid } = useParams();
  const location = useLocation();

  const [Mapndwins, setMapndwins] = useState("");
  const [ImgDate, setImgDate] = useState("");
  const [ndviVals, setndviVals] = useState({
    labels: [],
    datasets: [],
  });


  function getTheMap(res){
      setMapndwins('/api/crops/imagemap/'+ res.mapndwins);
      setImgDate(res.imgDate);

      console.log(res);
      const labels = [
        "<0",
        "0-.1",
        ".1-.2",
        ".2-.3",
        ".3-.4",
        ".4-.5",
        ".5-.6",
        ".6-.7",
        ".7-.8",
        ".8-.9",
        ".9-1",
      ];
      const dataSource = {
        labels,
        datasets: [
          {
            label: "NDWINS",
            data: res.ndwinsval,
            backgroundColor: "rgba(0, 170, 228, 1)",
          },
        ],
      };
      setndviVals(dataSource);   
  }

  function initViewer(dir){
    getMap(cropid+dir).then((res) => {
      if(res.status===0){
        notification.info({
          'message':'Imagenes no disponibles',
          'description': 'Generando imagenes'
        });
        getVisuals(cropid+'?date='+res.imgDate).then((res)=>{
          setMapndwins('/crops/imagemap/'+ res.mapndwins);    
        });
      }
      getTheMap(res);
    });     
  }

  useEffect(() => {
    if(!farmerData){
      initViewer(location.search);
    }else{
      getTheMap(farmerData);
    }
  }, [location]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Índice NDWINS",
      },
    },
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          padding: "20px",
        }}
      >
        Imagen satelital {ImgDate}
      </div>

      <Space
        size={20}
        direction="horizontal"
        align="top"
        style={{ padding: "20px" }}
      >
        <Space direction="horizontal">
            <Row>
              <Col span={18}>
              <Card>
                <Image
                  style={{ 
                    width: "100%",
                    minWidth:"150px",
                    minHeight:"86px",                
                    backgroundImage:"url("+bgimage+")"              
                  }}
                  src={Mapndwins}
                  preview={
                    {
                      mask:"Vista aumentada",
                      prevVisible,
                      scaleStep: 0.5,
                      src: Mapndwins,
                      onVisibleChange: (value) => {
                        setPrevVisible(value);
                      },                  
                    }
                }
                ></Image>
              </Card>
            </Col>           
          </Row>
          
              <Card>
                <Bar options={options} data={ndviVals} />
              </Card>
          
        </Space>
      </Space>
    </div>
  );
}

export default Water;